import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

export default function SidebarClient() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const menus = [
    { name: "Dashboard", path: "/client/dashboard", icon: "📊" },
    { name: "WhatsApp Connect", path: "/client/whatsapp", icon: "📱" },
    { name: "Bulk Message", path: "/client/bulk", icon: "✉️" },
    { name: "Auto Reply", path: "/client/auto-reply", icon: "🤖" },
    { name: "Contacts", path: "/client/contacts", icon: "👥" },
    { name: "Reports", path: "/client/reports", icon: "📄" },
    { name: "Plan Renewal", path: "/client/plan-renewal", icon: "🧾" },
    { name: "Settings", path: "/client/settings", icon: "⚙️" },
  ];

  return (
    <>
      {/* Mobile menu button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 bg-white text-gray-700 p-2 rounded-lg border border-gray-300"
      >
        ☰
      </button>

      {/* Sidebar */}
      <div className={`fixed lg:static top-0 left-0 w-64 bg-white h-screen border-r border-gray-200 p-5 flex flex-col transition-transform duration-300 ease-in-out lg:translate-x-0 ${isOpen ? "translate-x-0" : "-translate-x-full"} z-40`}>
        <h2 className="text-2xl font-bold mb-10 text-blue-600">User Panel</h2>
        
        <nav className="flex flex-col gap-2 flex-1">
          {menus.map((menu) => (
            <Link 
              key={menu.path}
              to={menu.path}
              onClick={() => setIsOpen(false)}
              className={`flex items-center gap-3 p-3 rounded-lg transition ${
                location.pathname === menu.path
                  ? "bg-blue-100 text-blue-600"
                  : "text-gray-700 hover:bg-blue-50 hover:text-blue-600"
              }`}
            >
              <span>{menu.icon}</span>
              {menu.name}
            </Link>
          ))}
        </nav>

        <button
          onClick={() => {
            // Keep deviceId so trusted-device 2FA keeps working.
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            localStorage.removeItem("userId");
            sessionStorage.clear(); // Clear CSRF and tab tenant session data
            window.location.href = "/login";
          }}
          className="mt-auto bg-gray-100 text-gray-600 p-3 rounded-lg font-bold hover:bg-red-50 hover:text-red-600 transition w-full"
        >
          Logout
        </button>
      </div>

      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black opacity-50 z-30"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
}